import {
    getWidgetAPI,
} from './api';

import CommonImages from '../../../../commons/images';

async function getWidget (widgetId) {
    const env = this.env;
    const res = await getWidgetAPI({
        widgetId,
        apiKey: env.appStore.widgetSettings.apikey,
        traceId: env.traceId,
        store: this,
    });

    // When having response error, redirect to error page if widget comes from a direct link, post data to appclient if widget is embedded a button
    if (res?.status !== 200) {
        if (env.appStore.directLink) {
            if (res?.response?.status === 403 &&
                res?.response?.data?.statusLong === "The API Key does not exist in the system"
            ) {
                env.errorsStore.dispatch({ code: 'INVALID_API_KEY' });
                env.appStore.gotoErrors();
                 
            } else if (res?.response?.status === 400 &&
                res?.response?.data?.errors?.id === "Invalid value for Button ID"
            ) {
                env.errorsStore.dispatch({ code: 'INVALID_BUTTON_ID' });
                env.appStore.gotoErrors();
            } else {
                env.errorsStore.dispatch({ code: 'InternalServerError' });
                env.appStore.gotoErrors();
            }
           
            return {
                logo: CommonImages.ECAL_LOGO_ROUND,
                error: true,
                logoHeight: 80,
                logoShadow: true,
            };
        }

        return {
            ...res?.response?.data,
            id: widgetId,
        };
    }

    return  await this.injectDefaults(res.data);
}

export default getWidget;